import { EmergencyNotificationHistory } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { EmptyStatePlaceholder, Heading, StyledFlex, Table } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import {
   useEmergencyNotificationHistoryColumns,
   useEmergencyNotificationHistoryDataConfiguration,
} from './EmergencyNotificationHistoryTable.hooks';

type EmergencyNotificationHistoryTableProps = {
   isConfigurationEnabled: boolean;
};

export const EmergencyNotificationHistoryTable = (props: EmergencyNotificationHistoryTableProps): JSX.Element => {
   const dataConfiguration = useEmergencyNotificationHistoryDataConfiguration();
   const columns = useEmergencyNotificationHistoryColumns();
   const isData = Boolean(dataConfiguration.dataPart?.data?.length);

   return (
      <StyledFlex direction={'column'} width={'982px'}>
         {props.isConfigurationEnabled || isData ? (
            <Heading
               content={translationKeys.emergencyNotificationHistory}
               type={'h2'}
               testId={'emergencyNotificationHistory'}
               margin={'8px'}
            />
         ) : null}

         <Table<EmergencyNotificationHistory>
            testId={'emergencyNotificationHistory'}
            columns={columns}
            dataConfiguration={dataConfiguration}
            keyExtractor={'id'}
            pageSize={10}
            placeholder={
               props.isConfigurationEnabled ? (
                  <EmptyStatePlaceholder
                     heading={translationKeys.emergencyNotificationHistoryEmpty}
                     subheading={translationKeys.emergencyNotificationHistoryEmptySubheading}
                     testId={'emergencyNotificationHistoryEmpty'}
                  />
               ) : (
                  <></>
               )
            }
         />
      </StyledFlex>
   );
};
